import axios from 'axios';
import {
  ACCOUNT_DEACTIVATED_CODE,
  clearAuthStorage,
  setDeactivatedRedirectMessage,
  DEACTIVATED_MESSAGE,
} from '../../utils/accountStatus';

// Auto-detect API URL based on current hostname
// Works for both localhost and production domain without changes
const getApiBaseUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  const port = window.location.port;

  // Production domain — always use same-origin /api (proxied by nginx)
  if (hostname !== 'localhost' && hostname !== '127.0.0.1') {
    return `${protocol}//${hostname}${port ? `:${port}` : ''}/api`;
  }

  // Local development — honor explicit env or default backend port
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  return 'http://localhost:5000/api';
};

const API_BASE_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const isDeactivated =
        error.response?.data?.code === ACCOUNT_DEACTIVATED_CODE ||
        String(error.response?.data?.message || '').toLowerCase().includes('deactivated');

      clearAuthStorage();
      if (isDeactivated) {
        setDeactivatedRedirectMessage(
          error.response?.data?.message || DEACTIVATED_MESSAGE
        );
      }

      if (!window.location.pathname.startsWith('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
